import { render } from "./Sousarirekilist.vue?vue&type=template&id=d4a16fb6&scoped=true&ts=true"
import script from "./Sousarirekilist.vue?vue&type=script&lang=ts"
export * from "./Sousarirekilist.vue?vue&type=script&lang=ts"

import "./Sousarirekilist.vue?vue&type=style&index=0&id=d4a16fb6&lang=css"
import "./Sousarirekilist.vue?vue&type=style&index=1&id=d4a16fb6&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1530414395/src/mediadept-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4a16fb6"]])

export default __exports__